export const APP_THEME_STORAGE_KEY = 'eplotera_theme_mode';
export const LEGACY_EDITOR_THEME_STORAGE_KEY = 'editor_theme_mode';

export type AppThemeMode = 'light' | 'dark';

export function isAppThemeMode(value: unknown): value is AppThemeMode {
  return value === 'light' || value === 'dark';
}

export function getNextAppThemeMode(mode: AppThemeMode): AppThemeMode {
  return mode === 'dark' ? 'light' : 'dark';
}

export function getSystemThemeMode(): AppThemeMode {
  if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  return 'dark';
}

type ThemeStorage = Pick<Storage, 'getItem'>;

export function getInitialAppThemeMode(storage?: ThemeStorage): AppThemeMode {
  if (storage) {
    try {
      const storedMode = storage.getItem(APP_THEME_STORAGE_KEY);
      if (isAppThemeMode(storedMode)) return storedMode;

      // Carry forward the old editor-only preference the first time the global
      // appearance setting is introduced.F
      const legacyEditorMode = storage.getItem(LEGACY_EDITOR_THEME_STORAGE_KEY);
      if (isAppThemeMode(legacyEditorMode)) return legacyEditorMode;
    } catch {
      // Storage may be unavailable in privacy-restricted browser contexts.
    }
  }

  return getSystemThemeMode();
}
